import { PredictionsPerTarget } from '@core/models/predictions.model';
import { Action, createReducer, on } from '@ngrx/store';
import { fullUpdatePredictions } from '@redux/actions/predictions.actions';

export interface PredictionsState {
  current: {
    [key: string]: PredictionsPerTarget;
  };
  default: {
    [key: string]: PredictionsPerTarget;
  };
}

export const initialPredictionsState: PredictionsState = {
  current: {},
  default: {}
};

const _predictionsReducer = createReducer(
  initialPredictionsState,
  on(fullUpdatePredictions, (state, { newPredictionsState }) => newPredictionsState)
);

export function predictionsReducer(state: PredictionsState | undefined, action: Action) {
  return _predictionsReducer(state, action);
}
